import React, { useState } from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import AboutBanner from "../AboutUs/AboutBanner";

import BoniAmin from "../../assets/team/Boni_amin.jpeg";
import SaroarHossinSagor from "../../assets/team/saruar_hossain.jpeg";
import Ibrahim from "../../assets/team/IBRAHIM_sir.jpeg";
import masumbillah from "../../assets/our-team/MasudBillah.jpg";
import MohammadSumon from "../../assets/team/Mohammad Sumon.jfif";
import AbdulMannan from "../../assets/our-team/Abdull_Manan.png";
import Mamun from "../../assets/team/MOHAMMADSUMON.jpg";
import BalalHossain from "../../assets/team/MD BELAL HOSSEN.jpg";
import SanaullahFakir from "../../assets/team/Md sanaullah.jpg";
import Kamrul from "../../assets/our-team/KamrulHassan.jpg";
import JosimMolla from "../../assets/team/JASHIM MULLAH.jpeg";
import Jahir from "../../assets/our-team/Jahir.png";
import Waliullah from "../../assets/team/Md Waliullah.jpg";
import BiplobHossain from "../../assets/team/Md. Biplob Hossain.jpg";
import Ujjal from "../../assets/our-team/ujjal.jpeg";
import Mikail from "../../assets/our-team/Mikail.jpg";
import AbdullahAlMamun from "../../assets/team/al-mamun.jpg";
import ArifulIslam from "../../assets/team/MD ARIFUL ISLAM.jfif";
import HabiburRahman from "../../assets/team/habib.jpg";
import Miraz from "../../assets/team/miraz howlader.jpg";
import KawsarHossain from "../../assets/team/KAWSAR.jpg";
import ZiaurRahman from "../../assets/team/Mufti Ziaur Rahman.jpg";
import Rasel from "../../assets/team/RASEL.jpeg";
import HarunOrRashid from "../../assets/team/HARUN_OR_RASHID.jpeg";
import DawoodurRahman from "../../assets/team/Dawood ur Rehman.jpg";
import JahangirAlam from "../../assets/team/JAHANGIR ALAM.jpg";
import alAmin from "../../assets/team/al-amin.jpeg";

export const managementData = [
  {
    id: 1,
    name: "MD. Boni Amin Fakir",
    title: "Chairman at Iconic Unity Group",
    description:
      "A visionary leader driving the strategic direction and sustainable growth of the entire organization.",
    image: BoniAmin,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 2,
    name: "Saroar Hossin Sagor",
    title: "Managing Director at Iconic Unity Group",
    description:
      "Driving the overall strategic vision, corporate growth, and technological expansion of Iconic Digital Solutions.",
    image: SaroarHossinSagor,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 3,
    name: "MD. Ibrahim",
    title: "Finance Director & CEO at Iconic Unity Group",
    description:
      "Overseeing financial planning, risk management, and ensuring robust fiscal health to sustain long-term business goals.",
    image: Ibrahim,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 4,
    name: "MD. Masud Billah",
    title: "Vice-Chairman at Iconic Unity Group",
    description:
      "Providing high-level governance, strategic leadership, and supporting executive decisions to foster organizational excellence.",
    image: masumbillah,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 5,
    name: "Mohammad Sumon",
    title: "Administration Director at Iconic Unity Group",
    description:
      "Managing daily operations, implementing corporate policies, and optimizing workplace workflow for maximum efficiency.",
    image: MohammadSumon,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 6,
    name: "Abdul Mannan",
    title: "Director at Iconic Unity Group",
    description:
      "Supporting strategic decision-making, strengthening corporate governance, and contributing to the long-term success of the organization.",
    image: AbdulMannan,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 7,
    name: "Md. Mamun",
    title: "Director at Iconic Unity Group",
    description:
      "Guiding operational excellence and shaping innovative strategies to deliver top tier software solutions.",
    image: Mamun,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 8,
    name: "Md. Balal Hossain",
    title: "Director at Iconic Unity Group",
    description:
      "Spearheading company operations and executing transformative business strategies for continuous expansion.",
    image: BalalHossain,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 9,
    name: "Md. Sanaullah Fakir",
    title: "Director at Iconic Unity Group",
    description:
      "Empowering corporate governance and fostering robust partnerships for long term business development.",
    image: SanaullahFakir,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 10,
    name: "Md. Kamrul Hassan",
    title: "Director at Iconic Unity Group",
    description:
      "Leading digital innovation and ensuring the delivery of cutting edge enterprise IT solutions.",
    image: Kamrul, // ছবিতে নেই
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 11,
    name: "Md. Josim Molla",
    title: "Director at Iconic Unity Group",
    description:
      "Driving the overall strategic vision, corporate growth, and technological expansion of Iconic Digital Solutions.",
    image: JosimMolla,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 12,
    name: "Jahir",
    title: "Director at Iconic Unity Group",
    description:
      "Overseeing financial planning, risk management, and ensuring robust fiscal health to sustain long-term business goals.",
    image: Jahir,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 13,
    name: "Md. Waliullah",
    title: "Director at Iconic Unity Group",
    description:
      "Leading digital innovation and ensuring the delivery of cutting edge enterprise IT solutions.",
    image: Waliullah,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 14,
    name: "Md. Al-Amin",
    title: "Director at Iconic Unity Group",
    description:
      "Managing daily operations, implementing corporate policies, and optimizing workplace workflow for maximum efficiency.",
    image: alAmin,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 15,
    name: "Md. Biplob Hossain",
    title: "Director at Iconic Unity Group",
    description:
      "Providing high-level governance, strategic leadership, and supporting executive decisions to foster organizational excellence.",
    image: BiplobHossain,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 16,
    name: "Md. Ujjal",
    title: "Director at Iconic Unity Group",
    description:
      "Promoting business innovation, strengthening stakeholder relationships, and supporting sustainable organizational growth.",
    image: Ujjal,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 17,
    name: "Md. Mikail",
    title: "Director at Iconic Unity Group",
    description:
      "Contributing to strategic planning, operational efficiency, and the successful execution of corporate initiatives.",
    image: Mikail,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 18,
    name: "Md. Abdullah-Al-Mamun",
    title: "Director at Iconic Unity Group",
    description:
      "Providing leadership in business development, fostering innovation, and driving sustainable value for the organization.",
    image: AbdullahAlMamun,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 19,
    name: "Md. Farhad Hossain",
    title: "Director at Iconic Unity Group",
    description:
      "Leading strategic initiatives, enhancing operational performance, and ensuring long-term organizational excellence.",
    image: "", // ছবিতে নেই
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 20,
    name: "Md. Ariful Islam",
    title: "Director at Iconic Unity Group",
    description:
      "Delivering strategic guidance, strengthening organizational performance, and promoting innovation across business operations.",
    image: ArifulIslam,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 21,
    name: "Habibur Rahman",
    title: "Director at Iconic Unity Group",
    description:
      "Building strong business partnerships, supporting corporate governance, and driving continuous organizational improvement.",
    image: HabiburRahman,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 22,
    name: "Md. Miraz",
    title: "Director at Iconic Unity Group",
    description:
      "Supporting executive leadership by implementing effective business strategies and encouraging sustainable corporate growth.",
    image: Miraz,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 23,
    name: "Md. Kawsar Hossain",
    title: "Director at Iconic Unity Group",
    description:
      "Driving organizational development through strategic planning, operational excellence, and collaborative leadership.",
    image: KawsarHossain,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 24,
    name: "Mufti Ziaur Rahman",
    title: "Director at Iconic Unity Group",
    description:
      "Providing visionary leadership, fostering ethical governance, and supporting the organization's long-term mission and values.",
    image: ZiaurRahman,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 25,
    name: "Dr. Md. Foisol Hossain",
    title: "Director at Iconic Unity Group",
    description:
      "Enhancing organizational performance through innovative leadership, strategic planning, and effective business management.",
    image: "", // ছবিতে নেই
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 26,
    name: "Md. Rasel",
    title: "Director at Iconic Unity Group",
    description:
      "Contributing to corporate success by improving operational efficiency and supporting key strategic business objectives.",
    image: Rasel,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 27,
    name: "Md. Harun Or Rashid",
    title: "Director at Iconic Unity Group",
    description:
      "Contributing to operational success and supporting core strategic initiatives across the organization.",
    image: HarunOrRashid,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 28,
    name: "A.N.M. Dawoodur Rahman",
    title: "Director at Iconic Unity Group",
    description:
      "Providing guidance and leadership to foster organizational growth and long-term goals.",
    image: DawoodurRahman,
    socials: { facebook: "#", linkedin: "#" },
  },
  {
    id: 29,
    name: "Md. Jahangir Alam",
    title: "Director at Iconic Unity Group",
    description:
      "Promoting corporate governance, business expansion, and operational excellence.",
    image: JahangirAlam,
    socials: { facebook: "#", linkedin: "#" },
  },
];

const ManagementCard = ({ member }) => {
  const [hovered, setHovered] = useState(false);

  return (
    // Converted to <a> tag with target="_blank" for professional new tab open experience
    <a
      href={`/about-us/board-of-directors/details/${member.id}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",
        background: "#fff",
        boxShadow: hovered
          ? "0 10px 30px rgba(192, 4, 212, 0.15)"
          : "0 2px 12px rgba(0,0,0,0.06)",
        transition: "box-shadow 0.3s ease, transform 0.3s ease",
        transform: hovered ? "translateY(-6px)" : "translateY(0)",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        textDecoration: "none", // standard reset
        cursor: "pointer",
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Image Area */}
      <div
        style={{
          position: "relative",
          width: "100%",
          paddingTop: "100%",
          background: "linear-gradient(135deg, #f3e8ff 0%, #fae8ff 100%)",
          overflow: "hidden",
          height: "450px",
        }}
      >
        {member?.image ? (
          <img
            src={member?.image}
            alt={member.name}
            style={{
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        ) : (
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f1f5f9",
            }}
          >
            <svg
              viewBox="0 0 100 100"
              width="80"
              height="80"
              style={{ margin: "auto" }}
            >
              <circle cx="50" cy="35" r="20" fill="#cbd5e1" />
              <ellipse cx="50" cy="85" rx="38" ry="25" fill="#cbd5e1" />
            </svg>
          </div>
        )}

        {/* Social Icons Overlay */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            background: "rgba(192, 4, 212, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "14px",
            opacity: hovered ? 1 : 0,
            transition: "opacity 0.3s ease",
          }}
        >
          <a
            href={member.socials.facebook}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(member.socials.facebook, "_blank");
            }}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#c004d4",
              fontSize: "16px",
              textDecoration: "none",
              transition: "transform 0.2s ease",
              transform: hovered ? "scale(1)" : "scale(0.8)",
            }}
          >
            <FaFacebookF />
          </a>
          <a
            href={member.socials.linkedin}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              window.open(member.socials.linkedin, "_blank");
            }}
            style={{
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#c004d4",
              fontSize: "16px",
              textDecoration: "none",
              transition: "transform 0.2s ease",
              transform: hovered ? "scale(1)" : "scale(0.8)",
            }}
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      {/* Text Area */}
      <div
        style={{
          padding: "20px",
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <h3
          style={{
            margin: "0 0 4px",
            fontSize: "20px",
            fontWeight: "700",
            color: "#1a1a2e",
          }}
        >
          {member.name}
        </h3>
        <p
          style={{
            margin: "0 0 12px",
            fontSize: "13px",
            fontWeight: "600",
            color: "#bd06d3",
          }}
        >
          {member.title}
        </p>
      </div>
    </a>
  );
};

const BoardOfDirectors = () => {
  return (
    <section
      style={{
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        width: "100%",
        paddingBottom: "80px",
        background: "#f8fafc",
      }}
    >
      {/* --- Full-Width Banner --- */}
      <AboutBanner
        text={"Our Directors"}
        des={
          "At Iconic Unity Group, we are committed to delivering innovative, reliable, and growth-driven solutions across multiple industries, helping businesses achieve long-term success."
        }
      ></AboutBanner>

      {/* --- Grid Content Area --- */}
      <div
        style={{ maxWidth: "1440px", margin: "0 auto", padding: "20px 20px" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
            gap: "30px",
            width: "100%",
            justifyContent: "center",
          }}
        >
          {managementData.map((member, index) => {
            const isLast = index === managementData.length - 1;

            return (
              <div
                key={member.id}
                style={{
                  width: "100%",
                  gridColumn:
                    isLast && managementData.length % 4 === 1
                      ? "1 / -1"
                      : "auto",
                  justifySelf: "start",
                  maxWidth:
                    isLast && managementData.length % 4 === 1
                      ? "345px"
                      : "100%",
                }}
              >
                <ManagementCard member={member} />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BoardOfDirectors;
